import { render, staticRenderFns } from "./tabCargoPdf.vue?vue&type=template&id=93c7293c&scoped=true"
import script from "./tabCargoPdf.vue?vue&type=script&lang=js"
export * from "./tabCargoPdf.vue?vue&type=script&lang=js"
import style0 from "./tabCargoPdf.vue?vue&type=style&index=0&id=93c7293c&prod&lang=scss"
import style1 from "./tabCargoPdf.vue?vue&type=style&index=1&id=93c7293c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c7293c",
  null
  
)

export default component.exports